import React, { useEffect } from "react";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  Button,
  Table,
  Card,
  Col,
  Form,
  Row,
  FormGroup,
} from "react-bootstrap";
import { IconPlus } from "@tabler/icons-react";
import useDebounce from "../../hooks/useDebounce";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import DynamicPagination from "../../components/DynamicPagination ";
import moment from "moment";
import { useFormContext, useFieldArray, get } from "react-hook-form";
import { toast } from "react-toastify";
import { trimTrailingZeros } from "../../utils/_helpers";
function SkuSearchPopUp({
  show,
  setShow,
  setSearchProps,
  onAddSku,
  searchProps,
  setCardSearch,
  cardSearch,
  calculateCosts,
  updateTextArea,
  searchType,
}) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [fetchedData, setFetchedData] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [searchDebounce, setSearchDebounce] = useState({
    searchSku: "",
    vendor_id: "",
    type: "",
    variant: "",
  });

  const {
    getValues,
    register,
    watch,
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  const vehicleId = watch("vehicleId");
  const contractVehicletype = watch("contractVehicletype");
  console.log("contractVehicletype", contractVehicletype);

  const { data: vendorlist, postData: fetchVendorList } = usePostRequest(
    API_ENDPOINTS.GET_VENDORS,
  );

  useEffect(() => {
    fetchVendorList({ page: 1, limit: 500, is_relevent: true });
  }, []);

  const handleVendorFilter = (e) => {
    setSearchDebounce((prev) => ({ ...prev, vendor_id: e.target.value }));
    setPage(1);
  };

  const handleTypeFilter = (e) => {
    setSearchDebounce((prev) => ({ ...prev, type: e.target.value }));
    setPage(1);
  };

  const handleVariantSearch = (e) => {
    setSearchDebounce((prev) => ({ ...prev, variant: e.target.value }));
    setPage(1);
  };

  useEffect(() => {
    if (searchProps) {
      console.log("searchProps", searchProps);
      setSearchDebounce({
        searchSku: searchProps.searchSku || "",
        productName: searchProps.productName || "",
        searchDescription: searchProps.searchDescription || "",
        searchVendor: searchProps.searchVendor || "",
        contract_type: searchProps.ContractName || "",
      });
    }
  }, [searchProps]);

  const handleAddClick = (product) => {
    const currentValues = getValues("cards") || [];
    if (contractVehicletype?.split(",").includes("product-bound")) {
      const isDuplicate = currentValues.some(
        (item, idx) =>
          item?.rowId === product?.raw_sku_id && idx !== searchProps.indexIs,
      );

      if (isDuplicate) {
        toast.error(
          `Product with SKU ${product.sku_display_name} already exists.`,
        );
        return;
      }
    }

    console.log("product", product);

    // const isDuplicate = currentValues.some(
    //   (item, idx) =>
    //     item?.skuIdUnique === product?.sku_id && idx !== searchProps.indexIs
    // );
    // if (isDuplicate) {
    //   toast.error(
    //     `Product with SKU ${product.sku_display_name} already exists.`
    //   );
    //   return;
    // }

    if (searchProps.indexIs !== undefined) {
      // UNCOMMENT FOR ORIGINAL VENDOR TRACKING
      const currentOriginalVendors = getValues("originalVendors") || {};
      setValue("originalVendors", {
        ...currentOriginalVendors,
        [searchProps.indexIs]: product?.Vendor?.display_name,
      });

      // setOriginalVendors((prev) => ({
      //   ...prev,
      //   [searchProps.indexIs]: product?.Vendor?.display_name,
      // }));

      // Clear any existing vendor warning for this index
      // setVendorWarnings((prev) => {
      //   const updated = { ...prev };
      //   delete updated[searchProps.indexIs];
      //   return updated;
      // });

      setValue(
        `cards[${searchProps.indexIs}].cost`,
        trimTrailingZeros(product?.aspetto_price),
        {
          shouldValidate: true,
        },
      );
      setValue(`cards[${searchProps.indexIs}].clin`, product?.clin_id, {
        shouldValidate: true,
      });

      if (contractVehicletype?.split(",").includes("product-bound")) {
        setValue(`cards[${searchProps.indexIs}].rowId`, product?.raw_sku_id, {
          shouldValidate: true,
        });
      }

      setValue(
        `cards[${searchProps.indexIs}].vendorPartner`,
        product?.Vendor?.display_name,
        { shouldValidate: true },
      );
      setValue(`cards[${searchProps.indexIs}].skuIdUnique`, product?.sku_id, {
        shouldValidate: true,
      });
      setValue(`cards[${searchProps.indexIs}].productName`, product?.name, {
        shouldValidate: true,
      });
      setValue(
        `cards[${searchProps.indexIs}].skuId`,
        product?.sku_display_name,
        {
          shouldValidate: true,
        },
      );
      // setValue(`cards[${searchProps.indexIs}].skuId`, product?.sku_id, {
      //   shouldValidate: true,
      // });

      setValue(
        `cards[${searchProps.indexIs}].skuDescription`,
        product?.description_sales,
        { shouldValidate: true },
      );
      setValue(
        `cards[${searchProps.indexIs}].purchase_description`,
        product?.description,
        { shouldValidate: true },
      );

      setValue(
        `cards[${searchProps.indexIs}].internalSku`,
        product?.internal_id || product?.vendor_sku,
        {
          shouldValidate: true,
        },
      );
      setValue(
        `cards[${searchProps.indexIs}].variantId`,
        product?.variant_id || product?.Product?.variant_id || 0,
        {
          shouldValidate: true,
        },
      );

      if (updateTextArea && searchProps.indexIs !== undefined) {
        updateTextArea(searchProps.indexIs, product?.description_sales);
      }

      setValue(`cards[${searchProps.indexIs}].um`, product?.uoi, {
        shouldValidate: true,
      });
      setValue(`cards[${searchProps.indexIs}].qty`, 1);
      setValue(
        `cards[${searchProps.indexIs}].customerCost`,
        product?.customer_price,
        { shouldValidate: true },
      );
      if (product?.customer_price === "0.00") {
        setValue(`cards[${searchProps.indexIs}].margin`, "8", {
          shouldValidate: true,
        });
      }
      // setValue(
      //   `cards[${searchProps.indexIs}].margin`,
      //   product?.margin_percent,
      //   { shouldValidate: true }
      // );

      const updatedCardSearch = [...cardSearch];
      updatedCardSearch[searchProps.indexIs] = {
        ...updatedCardSearch[searchProps.indexIs],
        showSuggestions: false,
      };
      setCardSearch(updatedCardSearch);
      calculateCosts();
      toast.success(
        `Product ${product.sku_display_name} is added successfully`,
      );
      if (
        !searchProps.searchSku &&
        !searchProps.productName &&
        !searchProps.searchDescription &&
        !searchProps.searchVendor
      ) {
        // console.log("first");
        const updatedCards = getValues("cards");
        const nextBlankIndex = updatedCards.findIndex(
          (card) => !card.skuIdUnique && !card.cost && !card.skuDescription,
        );
        setSearchProps({
          searchSku: "",
          productName: "",
          searchDescription: "",
          searchVendor: "",
          ContractName: searchProps.ContractName
            ? searchProps.ContractName
            : "",
          indexIs: nextBlankIndex !== -1 ? nextBlankIndex : undefined,
        });
      }
      const updatedCards = getValues("cards");
    } else {
      onAddSku(product);
      //calculateCosts()
    }
    // toast.success(
    //   `Added Successfully Product ${product.sku_id} is added successfully`
    // );
  };

  const handleSKUSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      searchSku: e.target.value,
    }));
    setPage(1);
  };
  const handleDescriptionSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      searchDescription: e.target.value,
    }));
  };

  const handleContractSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      contract_type: e.target.value,
    }));
  };

  const handleVendorSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      searchVendor: e.target.value,
    }));
  };

  const handleProductSearch = (e) => {
    setSearchDebounce((prevState) => ({
      ...prevState,
      productName: e.target.value,
    }));
  };

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
  };

  const handleLimitChange = (selectedLimit) => {
    setLimit(selectedLimit);
  };

  const { debounceSearch } = useDebounce(searchDebounce);

  const { postData: fetchProductSearch, data } = usePostRequest(
    API_ENDPOINTS.PRODUCT_SUGGETION,
  );

  const { postData: fetchContractProduct, data: dataContract } = usePostRequest(
    API_ENDPOINTS.GET_PRODUCTS,
  );

  useEffect(() => {
    setFetchedData(null);
    setSelectedVendor(null);
    const shouldAddContractType = contractVehicletype
      ?.split(",")
      .includes("product-bound");

    if (searchType === "skuAll") {
      fetchProductSearch({
        page,
        limit,
        module_type: "RFQ",
        vendor_id: searchDebounce?.vendor_id || null,
        type: searchDebounce?.type || undefined,
        is_variant: true,
        search: searchDebounce?.searchSku || null,
        variant: searchDebounce?.variant || null,
        ...(shouldAddContractType && { contract_type_id: vehicleId }),
      });
    } else if (searchType === "contract") {
      fetchContractProduct({
        module_type: "RFQ",
        page,
        limit,
        vendor_id: searchDebounce?.vendor_id || null,
        type: searchDebounce?.type || undefined,
        contract_type_id: vehicleId,
        search: searchDebounce?.searchSku || null,
        variant: searchDebounce?.variant || null,
      });
    } else {
      fetchProductSearch({
        page,
        limit,
        vendor_id: searchDebounce?.vendor_id || null,
        is_variant: true,
        type: searchDebounce?.type || undefined,
        module_type: "RFQ",
        search: searchDebounce?.searchSku || null,
        variant: searchDebounce?.variant || null,
        ...(shouldAddContractType && { contract_type_id: vehicleId }),
      });
    }
  }, [page, limit, searchDebounce]);

  useEffect(() => {
    if (data && data.data) {
      setFetchedData(data);
    }
  }, [data]);

  useEffect(() => {
    if (dataContract && dataContract.data) {
      setSelectedVendor(dataContract);
    }
  }, [dataContract]);

  const handleCloseModal = () => {
    setShow(false);
    setSearchDebounce({
      searchSku: "",
      productName: "",
      searchDescription: "",
      searchVendor: "",
      contract_type: "",
      variant: "",
    });
    setFetchedData(null);
    setSelectedVendor(null);
  };

  return (
    <>
      <Modal
        scrollable={true}
        show={show}
        onHide={handleCloseModal}
        className="skusearch"
        dialogClassName="modal-90vw"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Row className="w-100">
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search"
                autoComplete="off"
                value={searchDebounce.searchSku}
                onChange={handleSKUSearch}
              />
            </Col>
            <Col className="mb-3">
              <Form.Select
                value={searchDebounce.vendor_id}
                onChange={handleVendorFilter}
              >
                <option value="">All Vendors</option>
                {vendorlist?.data?.map((vendor) => (
                  <option
                    key={vendor.VendorContact?.vendor_id}
                    value={vendor.VendorContact?.vendor_id ?? 0}
                  >
                    {vendor.display_name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col className="mb-3">
              <Form.Select
                value={searchDebounce.type}
                onChange={handleTypeFilter}
              >
                <option value="">All Types</option>
                <option value="product">Product</option>
                <option value="kit">Kit</option>
                <option value="service">Service</option>
                <option value="consumable_material">Consumable/Material</option>
                <option value="other">Other</option>
              </Form.Select>
            </Col>
            <Col className="mb-3">
              <Form.Control
                type="text"
                placeholder="Search Variant"
                autoComplete="off"
                value={searchDebounce.variant}
                onChange={handleVariantSearch}
              />
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body className="vh-100">
          <div className="table-responsive">
            <Table>
              <thead responsive>
                <tr>
                  <th></th>
                  <th>INTERNAL ID</th>
                  <th className="">VENDOR</th>
                  <th className="">SKU</th>
                  <th className="">PRODUCT NAME</th>
                  <th className="">TYPE</th>
                  <th className="">DESCRIPTION</th>
                  {/* <th className="text-center">COST</th> */}
                </tr>
              </thead>
              {searchType === "contract" ? (
                <tbody>
                  {selectedVendor &&
                    selectedVendor?.data?.map((product, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <span
                              onClick={() => handleAddClick(product)}
                              className="avatar bg-green-lt"
                            >
                              <IconPlus />
                            </span>
                          </td>
                          <td className="text-start">
                            {product?.internal_id || product?.vendor_sku}
                          </td>
                          <td className="text-start">
                            {product?.Vendor?.display_name}
                          </td>
                          <td className="text-start text-orange">
                            {product?.variant_sku || product?.sku_display_name || ""}
                          </td>
                          <td className="text-start text-orange">
                            {product?.variant_name || product?.name || ""}
                          </td>
                          <td className="text-start">
                            {{
                              kit: "Kit",
                              "non-inventory": "Non-Inventory",
                              inventory: "Inventory",
                            }[product?.type] || ""}
                            {product?.kit_type ? ` (${product.kit_type})` : ""}
                          </td>
                          <td className="text-start">
                            {product?.description_sales?.length > 100
                              ? product.description_sales.slice(0, 100) + "..."
                              : product.description_sales}
                          </td>
                          {/* <td className="text-center">
                            {trimTrailingZeros(product?.aspetto_price)}
                          </td> */}
                        </tr>
                      );
                    })}
                </tbody>
              ) : (
                <tbody>
                  {fetchedData &&
                    fetchedData?.data?.map((product, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <span
                              onClick={() => handleAddClick(product)}
                              className="avatar bg-green-lt"
                            >
                              <IconPlus />
                            </span>
                          </td>
                          <td className="text-start">
                            {product?.internal_id || product?.vendor_sku}
                          </td>
                          <td className="text-start">
                            {product?.Vendor?.display_name}
                          </td>
                          <td className="text-start text-orange">
                            {product?.variant_sku || product?.sku_display_name || ""}
                          </td>
                          <td className="text-start text-orange">
                            {product?.variant_name || product?.name || ""}
                          </td>
                          {/* <td className="text-start">
                            {{
                              kit: "Kit",
                              "non-inventory": "Non-Inventory",
                              inventory: "Inventory",
                            }[product?.type] || ""}
                          </td> */}
                          <td className="text-start">
                            {{
                              kit: "Kit",
                              "non-inventory": "Non-Inventory",
                              inventory: "Inventory",
                            }[product?.type] || ""}
                            {product?.kit_type ? ` (${product.kit_type})` : ""}
                          </td>
                          <td className="text-start">
                            {product?.description_sales?.length > 100
                              ? product.description_sales.slice(0, 100) + "..."
                              : product.description_sales}
                          </td>
                          {/* <td className="text-center">
                            {trimTrailingZeros(product?.aspetto_price)}
                          </td> */}
                        </tr>
                      );
                    })}
                </tbody>
              )}
            </Table>
          </div>

          {searchType === "contract" ? (
            dataContract?.data?.length > 0 ? (
              <DynamicPagination
                totalPages={selectedVendor?.pagination?.totalPages}
                currentPage={page}
                onPageChange={handlePageChange}
                limitPerPage={limit}
                onLimitChange={handleLimitChange}
              />
            ) : (
              <p className="text-center mt-2">No matching records found.</p>
            )
          ) : data?.data?.length > 0 ? (
            <DynamicPagination
              totalPages={data?.pagination?.totalPages}
              currentPage={page}
              onPageChange={handlePageChange}
              limitPerPage={limit}
              onLimitChange={handleLimitChange}
            />
          ) : (
            <p className="text-center mt-2">No matching records found.</p>
          )}
          {/* {searchType === "contract" && dataContract?.data?.length > 0 ? (
            <DynamicPagination
              totalPages={selectedVendor?.pagination?.totalPages}
              currentPage={page}
              onPageChange={handlePageChange}
              limitPerPage={limit}
              onLimitChange={handleLimitChange}
            />
          ) : data?.data?.length > 0 ? (
            <DynamicPagination
              totalPages={data?.pagination?.totalPages}
              currentPage={page}
              onPageChange={handlePageChange}
              limitPerPage={limit}
              onLimitChange={handleLimitChange}
            />
          ) : (
            <p className="text-center mt-2">No matching records found.</p>
          )} */}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SkuSearchPopUp;
